import MuiList from "@mui/material/List";

export default function List(props) {
  return <MuiList {...props} />;
}
